<template>
  <div class="box">
    <video :id="videoId" autoplay></video>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RtspVideo",
  props: {
    rtspurl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      videoId: "video-" + Math.random().toString(36).substr(2, 9), // 自动生成唯一ID
      webRtcServer: null,
    };
  },
  computed: {
    ...mapState(["carParkList", "carParkIndex", "deviceList"]),
  },
  mounted() {
    this.$nextTick(() => {
      const videoElement = document.getElementById(this.videoId);
      if (!videoElement) {
        console.error("未找到 video 元素:", this.videoId);
        return;
      }

      // WebRtcStreamer 初始化
      this.webRtcServer = new WebRtcStreamer(
        this.videoId,
        location.protocol + "//127.0.0.1:8000"
      );

      // 连接 rtsp 流
      this.webRtcServer.connect(this.rtspurl);

      // 样式设置
      videoElement.style.objectFit = "fill";
      videoElement.play().catch(() => {});
    });
  },
  beforeUnmount() {
    if (this.webRtcServer) {
      this.webRtcServer.disconnect();
      this.webRtcServer = null;
    }
  },
};
</script>

<style scoped>
.box {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #000;
}

/* video 自适应父容器 */
video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
